import React from 'react';

interface DeleteDeviceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
  isDeletingSuccess?: boolean;
}

const DeleteDeviceModal: React.FC<DeleteDeviceModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting = false,
  isDeletingSuccess = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[var(--modal-overlay-background)] bg-opacity-50 flex items-center justify-center z-[100] zoomOutLevel">
      {/* Loading Overlay */}
      {isDeleting && (
        <div className="fixed inset-0 bg-[var(--modal-overlay-background)] bg-opacity-70 flex items-center justify-center z-[101]">
          <div className="flex flex-col items-center gap-4">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
            <p className="text-white text-lg font-medium">Deleting device...</p>
          </div>
        </div>
      )}
      <div className={`bg-[var(--modal-background)] rounded-2xl shadow-2xl ${isDeletingSuccess ? "max-w-60" : "max-w-sm"} w-full mx-4 transform transition-all ${isDeleting ? 'opacity-50 pointer-events-none' : ''}`}>
        {/* Modal Content */}
        <div className="p-8">
          {/* Warning Icon */}
          {isDeletingSuccess && <div className="flex justify-center mb-4">
            <img src={`${process.env.PUBLIC_URL}/SVGIcons/DeleteIcon.svg`} alt="Delete Icons" className="w-14 h-14" />
          </div>}
          
          {/* Title */}
          {!isDeletingSuccess && <h3 className="text-xl font-medium text-[var(--color-text)] mb-3">
            Are you sure?
          </h3>}
          
          {/* Message */}
          <p className={`text-base text-[var(--color-sub-title-text)] font-normal ${isDeletingSuccess ? "text-center" : "mb-6"} leading-relaxed`}>
            {isDeletingSuccess ? "Device deleted successfully." : "You want to delete this device? This action cannot be undone."}
          </p>
          
          {/* Action Buttons */}
         {!isDeletingSuccess && <div className="flex gap-4 justify-center">
            <button
              onClick={onClose}
              disabled={isDeleting}
              className="px-8 py-3 border-2 border-[var(--gradient-page-bottom-color)] text-[var(--color-terms-link)] rounded-lg hover:bg-[var(--button-hover)] focus:outline-none transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-bold text-base"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={isDeleting}
              className="px-12 py-3 bg-[#E67E7D] text-white rounded-lg hover:bg-red-600 focus:outline-none transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-bold text-base"
            >
              Delete
            </button>
          </div>}
        </div>
      </div>
    </div>
  );
};

export default DeleteDeviceModal;
